import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, freddyTheme } from '@coolblue-development/freddy';
import { Typography } from '@coolblue-development/freddy';
import { formatFullDate } from '@coolblue-development/next-formatting-utils/core';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useStoreAvailability } from '../../../../context/StoreAvailabilityContext.js';
import { OpeningHours } from './OpeningHours.js';
import { StoreHoursCollapsible } from './StoreHoursCollapsible.js';
export const StoreOpeningHours = () => {
    const { language, subsidiary } = useRequestContext();
    const { weeklyOpeningHours, isPreOrder, expectedReleaseDate } = useStoreAvailability();
    const isReleaseDateWithinTwoWeeksFromNow = expectedReleaseDate &&
        new Date(expectedReleaseDate) <= new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);
    const storeHoursCollapsibleIsVisible = !isPreOrder || (isPreOrder && isReleaseDateWithinTwoWeeksFromNow);
    return (_jsxs(_Fragment, { children: [isPreOrder && !isReleaseDateWithinTwoWeeksFromNow && expectedReleaseDate && (_jsx(Typography, { children: `${formatFullDate({
                    date: new Date(expectedReleaseDate),
                    language,
                    subsidiary,
                })}` })), storeHoursCollapsibleIsVisible && (_jsx(StoreHoursCollapsible, { children: _jsx(Flex, { flow: "column", sx: { marginBottom: freddyTheme.spacing[400] }, children: weeklyOpeningHours.map(schedule => {
                        return _jsx(OpeningHours, { schedule: schedule }, schedule.scheduleDate);
                    }) }) }))] }));
};
//# sourceMappingURL=StoreOpeningHours.js.map